export const SET_COMMUNITY_FEE = 'SET_COMMUNITY_FEE'
export const SET_ENERGY_CREDIT_FEE = 'SET_ENERGY_CREDIT_FEE'
export const SET_PROCESSING_FEE = 'SET_PROCESSING_FEE'
export const SET_TRANSACTION_STATUS = 'SET_TRANSACTION_STATUS'
export const SET_PAYMENT_GATEWAY = 'SET_PAYMENT_GATEWAY'
